import { Buffer } from "buffer";
export var b64toBlob = function (base64Data, type) {
    var byteCharacters = Buffer.from(base64Data, "base64").toString("binary");
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += 512) {
        var slice = byteCharacters.slice(offset, offset + 512);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: type || "application/pdf" });
};
export function blobToBase64(blob) {
    return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onloadend = function () { return resolve(reader.result); };
        reader.readAsDataURL(blob);
    });
}
export function createFileLink(base64Encoded) {
    return URL.createObjectURL(b64toBlob(base64Encoded));
}
export function downloadBase64File(base64Encoded, filename) {
    var url = createFileLink(base64Encoded);
    var link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
}
export function downloadFile(url, filename) {
    var link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
}
